import { useEffect, useState } from "react";
import ADAIcon from "../icons/ADAIcon";
import { Button, Modal } from "antd";
import { LogoDto } from "../../domain/BrandDataDto";
import BrandApi from "../../api/BrandApi";
import { env } from "../../env/env";
import "./AltTextModal.scss";
import { QuestionCircleOutlined } from "@ant-design/icons";
import AltTextHelpModal from "./AltTextHelpModal";

export interface AltTextModalProps {
  open: boolean;
  onClose: () => void;
  selectedLogo: LogoDto;
  logos: LogoDto[];
  setLogos: (logos: LogoDto[]) => void;
}

export function AltTextModal({ open, onClose, selectedLogo, logos, setLogos }: AltTextModalProps) {
  const [curText, setCurText] = useState('');
  const [imgUrl, setImgUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [isHelpModal, setHelpModal] = useState(false);

  function setAltText() {
    setLoading(true);
    BrandApi.updateLogoAltText(selectedLogo.id!, curText).then(resp => {
      console.log(resp);
      const uploadedLogosCopy = [...logos];
      const toUpdate = uploadedLogosCopy.find(i => i.id === selectedLogo.id)!;
      toUpdate.altText = curText;
      setLogos([...uploadedLogosCopy]);
      setLoading(false);
    })

    resetAndClose();
  }

  useEffect(() => {
    if (!selectedLogo || !selectedLogo.id) return;
    setImgUrl(`${env.s3Path}/${selectedLogo.path}`);
    if (selectedLogo.altText) {
      setCurText(selectedLogo.altText);
    } else {
      setCurText('');
    }
  }, [selectedLogo])

  function resetAndClose() {
    window.localStorage.setItem('alttext-just-uploaded', '');
    onClose();
  }

  return <Modal
    className={"one alt-text-modal"}
    onCancel={() => onClose()}
    width={570}
    open={open}
  >
    <div className="img-cont">
      <img src={imgUrl} alt="Selected logo" />
    </div>
    <h3>
      <ADAIcon/> 
      Accessibility Text 
      <div className="help-btn" onClick={() => setHelpModal(true)}><QuestionCircleOutlined/></div>
    </h3>
    <p>Image description necessary for ADA compliance and screen readers</p>
    <textarea placeholder="Description 125 chars max" maxLength={125} value={curText} onChange={(e: any) => setCurText(e.target.value)} />
    
    <footer>
      <Button type="primary" className={`btn primary`} disabled={!curText} loading={loading} onClick={setAltText}>Done</Button>
      {window.localStorage.getItem('alttext-just-uploaded') === 'true' &&
        <Button className={`btn`} loading={loading} onClick={() => resetAndClose()}>Skip for now</Button>}
    </footer>

    <AltTextHelpModal open={isHelpModal} onClose={() => setHelpModal(false)}/>
  </Modal>
}
